const ZillowSubscriptionStatus = ({
    zuid = 0,
    enrollmentId = 0,
    referenceId = '',
    subscriptionType = '',
    explicitStatus = '',
    implicitStatus = '',
    status = '',
    enrollmentToken = '',
    isEmailable = false,
    unsubscribeLink = '',
} = {}) => ({
    zuid: Number(zuid),
    enrollmentId: Number(enrollmentId),
    referenceId: String(referenceId),
    subscriptionType: String(subscriptionType),
    explicitStatus: String(explicitStatus),
    implicitStatus: String(implicitStatus),
    status: String(status),
    enrollmentToken: String(enrollmentToken),
    isEmailable: Boolean(isEmailable),
    unsubscribeLink: String(unsubscribeLink),
});

const ZillowSubscriptionStatusesByType = (
    zillowSubscriptionStatuses = []
) => ({
    statusesByType: zillowSubscriptionStatuses.map(status => new ZillowSubscriptionStatus(status))
        .reduce((map, status) => {
            map[status.subscriptionType] = status;
            return map;
        }, {})
});

export default ZillowSubscriptionStatusesByType;
